import { render } from "./CommonAreas.vue?vue&type=template&id=2e01ce5c"
import script from "./CommonAreas.vue?vue&type=script&lang=js"
export * from "./CommonAreas.vue?vue&type=script&lang=js"
script.render = render

export default script